import '@angular/localize/init';
import 'zone.js';

declare global {
	interface Window {
		// please keep the alphabetical ordering
		VantageShellExtension: any;
	}
}
